<template>
  <div class="news_warp">
    <div class="news_banner">
      <h1 class="news_banner_title">媒体报道</h1>
    </div>
    <div class="news_list_warp">
      <div class="news_breadcrumb">
        <div class="breadcrumb breadcrumb_l">
          关于我们
        </div>
        <div class="breadcrumb breadcrumb_r">
          媒体报道
        </div>
      </div>
      <ul class="newslist">
        <li class="news_item" v-for="item in newsList">
          <div class="news_time">
            <div class="time">
              <div class="time_day">{{item.ReleaseTime[2]}}</div>
              <div>{{item.ReleaseTime[0]}}年{{item.ReleaseTime[1]}}月</div>
            </div>
            <div class="circle">
            </div>
          </div>
          <div class="news_detail">
            <div class="news_detail_img">
              <img :src="item.CoverImageURl" alt="">
            </div>
            <div class="news_detail_text">
              <h2 class="detail_text_title">
                {{item.Title}}
              </h2>
              <div class="detail_text_source">
                【{{item.Source}}】
              </div>
              <div class="">
                <p class="detail_text_body">
                  {{item.Body}}
                  <a :href="item.URL" class="click_detail" target="_blank">查看详情</a>
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="news_pagination">
        <el-pagination
                background
                :pager-count="pagerCount"
                :page-size="pagesize"
                :current-page="currentPage"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="totalNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
	import fetch from '../utils/fetch';
	import bus from '../utils/bus'
	export default {
		data(){
			return{
				newsList:[],
				totalNum:0,
				pagerCount:5,
				pagesize:6,
				currentPage:1
      }
    },
		mounted(){
			bus.$emit('customEvent','newslist');
			this._getNewsList(1)
		},
    methods:{
	    handleCurrentChange(val) {
		    //console.log(`当前页: ${val}`);
        this.currentPage = val;
		    this._getNewsList(val);
		    document.body.scrollTop = 0;
		    document.documentElement.scrollTop = 0;
	    },
	    _getNewsList(p){
		    fetch({
			    url: '/media/reports',
			    method: 'get',
			    params:{pagenum:p,pagesize:this.pagesize}
		    }).then(res => {
			    this.newsList = res.data.Reports;
			    this.totalNum = res.data.Total;
			    this.newsList.map(item => {
				    item.ReleaseTime = item.ReleaseTime.split('-');
				    return item;
			    })
		    })
	    }
    }
  }
</script>

<style>
  .news_banner{
    background: url("http://bu.dressplus.cn/cdn/media/reports/img/15305235334067.jpeg") no-repeat center;
    background-position-y: 26%;
    height: 344px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .news_banner_title{
    color: #fff;
    font-size: 32px;
  }
  /*列表*/
  .news_list_warp{
    width: 65%;
    margin: 0 auto;
  }
  /*面包屑*/
  .news_breadcrumb{
    display: flex;
    position: relative;
    z-index: 2;
    padding-top: 35px;
    border-bottom: 30px #ffffff solid;
  }
  .breadcrumb{
    width: 120px;
    height: 36px;
    color: #fff;
    border-radius: 0 18px 18px 0;
    text-align: center;
    line-height: 36px;
  }
  .breadcrumb_l{
    background: rgb(0,140,238);
  }
  .breadcrumb_r{
    width: 138px;
    margin-left: -18px;
    background: rgb(0,111,190);
    z-index: -1;

  }
  .newslist{
    margin-top: -20px;
  }
  .news_item{
    width: 100%;
    display: flex;
    height: 260px;
    justify-content: space-between;
  }
  .news_time{
    width: 13%;
    border-right: 1px #c2c8d4 solid;
    position: relative;
  }
  .time{
    width: 70%;
    border: 1px #999  solid;
    border-radius: 4px;
    text-align: center;
    top: 20px;
    position: relative;
    padding: 10px 0 10px;
  }
  .time_day{
    font-size: 24px;
    color: #5c5c5c;
    padding: 0 0 10px;
  }
  .circle{
    position: absolute;
    width: 20px;
    height: 20px;
    background: rgb(240,244,255);
    border-radius: 10px;
    text-align: center;
    line-height: 20px;
    right: -10px;
    top: 40px;
  }
  .circle:after{
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background: rgb(51,229,235);
  }
  /*详情*/
  .news_detail{
    width: 85%;
    border-bottom: 1px #c2c8d4 solid;
    box-sizing: border-box;
    padding: 20px 0;
    display: flex;
  }
  .news_detail_img{
    width: 30%;
    height: 100%;
    min-width: 317px;
  }
  .news_detail_img img{
    vertical-align: middle;
    width: 100%;
    height: 100%;
  }
  .news_detail_text{
    box-sizing: border-box;
    padding: 20px 0;
    margin-left: 20px;
    width: 65%;
    min-width: 406px;
  }
  .detail_text_title{
    font-size: 24px;
    color: #000;
  }
  .detail_text_title:hover{
    color: #009bee;
  }
  .detail_text_source{
    font-size: 14px;
    color: #5c5c5c;
    margin: 20px 0 30px;
  }
  .detail_text_body{
    font-size: 15px;
    color: #1d2528;
    line-height: 24px;
  }
  .click_detail{
    color: #009bee;
    font-size: 15px;
    border-bottom: 1px #009bee solid;
  }
  /*分页*/
  .news_pagination{
    margin: 20px 0;
    position: relative;
    height: 32px;
  }
  .news_pagination .el-pagination{
    position: absolute;
    right: 0;
    top: 0;
  }
</style>


// WEBPACK FOOTER //
// src/views/newslist.vue